import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-sync",
  templateUrl: "./med-icon-sync.component.html",
})
export class MedIconSyncComponent extends SvgMixinComponent {}
